import { Pressable, type PressableProps } from 'react-native';

import { AppText } from '@/components/ui/app-text';
import { colors, radius, spacing } from '@/theme/tokens';

interface PrimaryButtonProps extends Omit<PressableProps, 'children'> {
  label: string;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
}

/**
 * Buttons are ALWAYS solid filled (Wojtek's hard UI rule — no ghost/outline).
 * Pressed state: subtle scale 0.98 per DESIGN.md.
 */
export function PrimaryButton({ label, variant = 'primary', disabled, style, ...rest }: PrimaryButtonProps) {
  const bg = disabled ? colors.disabledBg : variant === 'primary' ? colors.primary : colors.surface;
  const fg = disabled ? colors.disabledText : variant === 'primary' ? '#FFFFFF' : colors.navy;
  return (
    <Pressable
      accessibilityRole="button"
      disabled={disabled}
      {...rest}
      style={({ pressed }) => [
        {
          backgroundColor: pressed && !disabled && variant === 'primary' ? colors.primaryPressed : bg,
          borderRadius: radius.button,
          paddingVertical: spacing.md,
          paddingHorizontal: spacing.lg,
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 48,
          transform: [{ scale: pressed && !disabled ? 0.98 : 1 }],
        },
        typeof style === 'function' ? undefined : style,
      ]}
    >
      <AppText variant="labelLg" color={fg}>
        {label}
      </AppText>
    </Pressable>
  );
}
